module.exports = __webpack_public_path__ + "static/img/collection2.f293ba34.png";